export const PRODUCTIONS_RESET_STATE = 'PRODUCTIONS_RESET_STATE';
export const PRODUCTIONS_CURRENT_ITEM = 'PRODUCTIONS_CURRENT_ITEM';

export const PRODUCTIONS_REQUEST_LOADING = 'PRODUCTIONS_REQUEST_LOADING';
export const PRODUCTIONS_REQUEST_SUCCESS = 'PRODUCTIONS_REQUEST_SUCCESS';
export const PRODUCTIONS_REQUEST_FAILED = 'PRODUCTIONS_REQUEST_FAILED';

export const PRODUCTIONS_CURRENT_ACTION = 'PRODUCTIONS_CURRENT_ACTION';
export const PRODUCTIONS_RESET_ACTION = 'PRODUCTIONS_RESET_ACTION';
